'use strict';

(function () {
  if (!customElements.get('accordion-panel')) {
    class AccordionPanel extends HTMLElement {
      constructor() {
        super();
        this.toggleButton = null;
        this.dropdownContent = null;
      }

      connectedCallback() {
        this.setupElements();
        this.showContent();
      }

      setupElements() {
        this.toggleButton = this.querySelector('[data-component="toggle"]');
        this.dropdownContent = this.querySelector('[data-component="dropdown"]');
      }

      showContent() {
        this.classList.remove('js-active');

        if (this.dropdownContent) {
          this.dropdownContent.hidden = false;
          this.dropdownContent.removeAttribute('aria-hidden');
        }

        if (this.toggleButton) {
          this.toggleButton.removeAttribute('aria-expanded');
        }
      }
    }

    customElements.define('accordion-panel', AccordionPanel);
  }
})();